import r from 'routes'

import { App } from '@/apps'
import { NavigationItem } from '@/components/navigation/types'

import { AdminRole } from './out/admin'

export const appNavigation: (role: AdminRole) => Record<App, NavigationItem[]> = (role: AdminRole) => {
  const isAdmin = ['admin', 'owner'].includes(role)

  return {
    'one-time-passcode': [
      {
        title: 'Dashboard',
        path: r.apps['one-time-passcode'].root,
      },
      {
        title: 'Authentications',
        path: r.apps['one-time-passcode'].authentications,
      },
      {
        title: 'Configuration',
        path: r.apps['one-time-passcode'].settings.root,
        hidden: !isAdmin,
      },
    ],
    'document-signature': [
      {
        title: 'Dashboard',
        path: r.apps['document-signature'].root,
      },
      {
        title: 'Signatures',
        path: r.apps['document-signature'].signatures,
      },
      {
        title: 'Documents',
        path: r.apps['document-signature'].documents.root,
        hidden: !isAdmin,
      },
      {
        title: 'Configuration',
        path: r.apps['document-signature'].settings.root,
        hidden: !isAdmin,
      },
    ],
    'e-form': [
      {
        title: 'Dashboard',
        path: r.apps['e-form'].root,
      },
      {
        title: 'Submissions',
        path: r.apps['e-form'].submissions,
      },
      {
        title: 'Forms',
        path: r.apps['e-form'].forms.root,
        hidden: !isAdmin,
      },
      {
        title: 'Configuration',
        path: r.apps['e-form'].settings.root,
        hidden: !isAdmin,
      },
    ],
    'gateway-payments': [
      {
        title: 'Dashboard',
        path: r.apps['gateway-payments'].root,
      },
      {
        title: 'Payments',
        path: r.apps['gateway-payments'].payments,
      },
      {
        title: 'Configuration',
        path: r.apps['gateway-payments'].settings.root,
        hidden: !isAdmin,
      },
    ],
    passkeys: [
      {
        title: 'Dashboard',
        path: r.apps.passkeys.root,
      },
      {
        title: 'Activity',
        path: r.apps.passkeys.activity,
      },
      {
        title: 'Enrollments',
        path: r.apps.passkeys.enrollments,
      },
      {
        title: 'Configuration',
        path: r.apps.passkeys.settings.root,
        hidden: !isAdmin,
      },
    ],
    payments: [
      {
        title: 'Dashboard',
        path: r.apps.payments.root,
      },
      {
        title: 'Payments',
        path: r.apps.payments.payments,
      },
      {
        title: 'Product Catalog',
        path: r.apps.payments.products,
      },
      {
        title: 'Configuration',
        path: r.apps.payments.settings.root,
        hidden: !isAdmin,
      },
    ],
    'identity-verification': [
      {
        title: 'Dashboard',
        path: r.apps['identity-verification'].root,
      },
      {
        title: 'Verifications',
        path: r.apps['identity-verification'].verifications,
      },
      {
        title: 'Configuration',
        path: r.apps['identity-verification'].settings.root,
        hidden: !isAdmin,
      },
    ],
  }
}
